const FEATURE_FLAGS = Object.freeze({
   showAltFeaturedImage: Object.freeze({
      key: 'plp-category-featured-image',
      defaultValue: false,
   }),
});

const FEATURE_FLAG_KEYS = Object.freeze(
   Object.fromEntries(Object.entries(FEATURE_FLAGS).map(([name, { key }]) => [name, key]))
);

const FEATURE_FLAG_DEFAULTS = Object.freeze(
   Object.fromEntries(
      Object.values(FEATURE_FLAGS).map(({ key, defaultValue }) => [key, defaultValue])
   )
);

export { FEATURE_FLAGS, FEATURE_FLAG_DEFAULTS, FEATURE_FLAG_KEYS };
